import styles from './numeric-input.module.css'

import React from 'react'

import cn from 'clsx'

import { TextField } from 'components/ds'

type NumericInputProps = {
  value: string
  onValueChange: (_raw: string) => void
  onKeyDown: React.KeyboardEventHandler
  placeholder?: string
  autoFocus?: boolean
  hasError?: boolean
  /** 'fixed' stands alone at 150px; 'fluid' flexes to share a row. */
  width?: 'fixed' | 'fluid'
}

/** Text input with numeric inputMode so callers can intercept and reject letters. */
export const NumericInput = ({
  value,
  onValueChange,
  onKeyDown,
  placeholder,
  autoFocus = false,
  hasError = false,
  width = 'fixed',
}: NumericInputProps) => (
  <TextField.Root
    type="text"
    inputMode="numeric"
    value={value}
    onChange={e => onValueChange(e.target.value)}
    onKeyDown={onKeyDown}
    placeholder={placeholder}
    autoFocus={autoFocus}
    color={hasError ? 'red' : undefined}
    className={cn(styles[width], hasError && styles.error)}
  />
)
